var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "19.5px",
    viewBox: "0 0 26 19.5",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PerfilUsuario"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1012 -281L-986 -281L-986 -261.5L-1012 -261.5L-1012 -281Z",
    id: "PerfilUsuario",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PerfilUsuario",
    component: "71873b16-fedc-467b-aa83-2d6bf0d33b5d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3.05005L13 3.05005L13 17.05L3 17.05L3 3.05005Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0208 0L2.97923 0C1.33578 0 0 1.33578 0 2.97923L0 16.5208C0 18.1642 1.33578 19.5 2.97923 19.5L23.0208 19.5C24.6642 19.5 26 18.1642 26 16.5208L26 2.97923C26 1.33578 24.6642 0 23.0208 0L23.0208 0ZM8.12502 4.33325C9.6179 4.33325 10.8333 5.54883 10.8333 7.04172C10.8333 8.53441 9.6179 9.74998 8.12502 9.74998C6.63213 9.74998 5.41675 8.53441 5.41675 7.04172C5.41675 5.54883 6.63213 4.33325 8.12502 4.33325L8.12502 4.33325ZM13 14.3542C13 14.8027 12.636 15.1667 12.1875 15.1667L4.0625 15.1667C3.614 15.1667 3.25 14.8027 3.25 14.3542L3.25 13.8125C3.25 12.169 4.58578 10.8333 6.22923 10.8333L10.0208 10.8333C11.6642 10.8333 13 12.169 13 13.8125L13 14.3542ZM21.9375 15.1667L15.9792 15.1667C15.5307 15.1667 15.1667 14.8027 15.1667 14.3542C15.1667 13.9057 15.5307 13.5417 15.9792 13.5417L21.9375 13.5417C22.386 13.5417 22.75 13.9057 22.75 14.3542C22.75 14.8027 22.386 15.1667 21.9375 15.1667L21.9375 15.1667ZM21.9375 10.8333L15.9792 10.8333C15.5307 10.8333 15.1667 10.4693 15.1667 10.0208C15.1667 9.57225 15.5307 9.20825 15.9792 9.20825L21.9375 9.20825C22.386 9.20825 22.75 9.57225 22.75 10.0208C22.75 10.4693 22.386 10.8333 21.9375 10.8333L21.9375 10.8333ZM21.9375 6.5L15.9792 6.5C15.5307 6.5 15.1667 6.136 15.1667 5.6875C15.1667 5.239 15.5307 4.875 15.9792 4.875L21.9375 4.875C22.386 4.875 22.75 5.239 22.75 5.6875C22.75 6.136 22.386 6.5 21.9375 6.5L21.9375 6.5Z",
    id: "Shape",
    fill: "#07C180",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape08);
export default __webpack_public_path__ + "static/media/shape08.0ed819d0079a4f76f77981aebcddb2b6.svg";
export { ForwardRef as ReactComponent };